import { render, staticRenderFns } from "./mediaplacement-grid.vue?vue&type=template&id=bddb94bc&scoped=true&"
import script from "./mediaplacement-grid.vue?vue&type=script&lang=js&"
export * from "./mediaplacement-grid.vue?vue&type=script&lang=js&"
import style0 from "./mediaplacement-grid.vue?vue&type=style&index=0&id=bddb94bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddb94bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardTitle,VCol,VDataTable,VIcon,VRow,VSnackbar,VTextField,VTooltip})
